import { type ReactNode } from "react";
import { Flex } from "@chakra-ui/react";
import CDS from "design-system";

interface HeaderStatCardProps {
  eyebrow: string;
  hero: ReactNode;
  texture?: ReactNode;
  flex?: string | number;
  minW?: string;
}

export default function HeaderStatCard({ eyebrow, hero, texture, flex = "1", minW = "200px" }: HeaderStatCardProps) {
  return (
    <CDS.Card flex={flex} minW={minW} padding="small">
      <Flex direction="column" gap={1}>
        <CDS.Text11 color="content.tertiary" textTransform="uppercase" letterSpacing="wider" fontWeight="600">
          {eyebrow}
        </CDS.Text11>
        {hero}
        {texture && <CDS.Text12 color="content.tertiary">{texture}</CDS.Text12>}
      </Flex>
    </CDS.Card>
  );
}
